import cx from 'classnames'
import { useEffect, useState } from 'react'

import Container from 'react-bootstrap/Container'
import { scrollToTop } from '../../../global/helpers'
import Icon from '../../Icon/Icon'
import Typography from '../../Typography/Typography'
import useTitle from './hooks/useTitle'

import './InfoWindow.scss'

const InfoWindow = ({
    title,
    description,
    element,
    color,
    isOpen = true,
    onClose,
    withTimer = false,
    withScroll = false,
}) => {
    const [timeoutHide, setTimeoutHide] = useState(false)
    const titleByColor = useTitle(color)

    const classNameWindow = cx(`info-window info-window--${color} d-flex position-relative`)

    const typographyColor = color !== 'white' ? 'primary' : 'darkerPrimary'

    const content = element
        ? element
        : description && (
              <Typography variant={'p'} color={typographyColor}>
                  {description}
              </Typography>
          )

    useEffect(() => {
        let timer
        if (withTimer) {
            setTimeoutHide(false)

            timer = setTimeout(() => {
                setTimeoutHide(true)
                if (onClose) onClose()
            }, 15000)
        }

        if (withScroll) {
            scrollToTop()
        }

        return () => clearTimeout(timer)
    }, [description])

    return (
        <>
            {isOpen && (
                <Container fluid className={cx(classNameWindow, timeoutHide && 'd-none')}>
                    {onClose && (
                        <Icon
                            name={'cross'}
                            className={'cross-icon position-absolute top-0 end-0'}
                            onClick={onClose}
                            role={'button'}
                        />
                    )}
                    <div className={'d-flex'}>
                        <Icon name={color === 'white' ? 'info-blue' : 'info'} className={'my-auto me-3'} />
                        <Typography variant={'subtitle'} className={'text-nowrap my-auto me-3'} color={typographyColor}>
                            {title ?? titleByColor}
                        </Typography>
                    </div>
                    <div className={`info-window--border ${color === 'white' && 'border-lighterPrimary'}`} />
                    {<div className={'w-100'}>{content}</div>}
                    {withTimer && !timeoutHide && <div className={'progress'} />}
                </Container>
            )}
        </>
    )
}

export default InfoWindow
